module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQBAMAAAB8P++eAAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAqUExURUxpcf///////////////////////////////////////////////////+bWS5kAAAANdFJOUwC/YO+AIKIQ31DPOG+hByq5AAAA6UlEQVR42u3WPwrCMBiH4VD8Qze9QXFxcnYKCCJOgoNOLs5CQdRV8AKFXsDVzdFdvIFGahVyF2saa4eaX7q12nd+ICEZvo8UZbvFjPLE2M6Nu5Vgyfm9jzMDp5BWBAdc2fXtShzUkbCF4D10ZQdBNhewAlh09hrDtrwi7CKgjaEn4B5DX0COYxLicgH/t7pG2u9YwN+C51PjlQ3hhogMCI8kjCJo6cJa6Ex4tHcYB026uf4Zqgsd7B7a4yPdQFpieJPjGjYVsEqR84dEtIVX1F4V0i4fxHBUjrkkaqSQrE9imd9XriYpynRPpmcFlqBP6DgAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images_member/Frame@2x(1).png
// module id = Cfuq
// module chunks = 1